<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <OnFssAcces :fss=fss :rliss="rliss" ></OnFssAcces>
      </div>
    </div>
  </div>
</template>

<script>
import OnFssAcces from '@/components/OnFssAcces.vue'
import axios from 'axios';

export default {
  data: function() {return {
    fss: [],
    rliss: []
  }},

  name: 'OnAcces',
  components: {
    OnFssAcces,
  },
  methods: {
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/acces.php',
          { })
        .then(response => {
          this.fss = response.data.fss;
          this.rliss = response.data.rliss;
        })
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>
